import {
  Pagination as PaginationRoot,
  PaginationContent,
  PaginationItem,
  PaginationLink,
  PaginationNext,
  PaginationPrevious,
} from '@/components/ui/pagination';
import { cn } from '@/utils/styleUtils';
import { useEffect } from 'react';

interface PaginationInfo {
  pageNumber: number;
  pageSize: number;
  count: number;
  pageCount: number;
}

interface IProps {
  className?: string;
  currentPage: number;
  setCurrentPage: (state: number) => void;
  paginationInfo?: PaginationInfo;
}

export const Pagination = ({ className, currentPage, setCurrentPage, paginationInfo }: IProps) => {
  const pageCount = paginationInfo?.pageCount ?? 1;

  useEffect(() => {
    if (paginationInfo?.pageCount && currentPage > paginationInfo.pageCount) {
      setCurrentPage(paginationInfo.pageCount);
    }
  }, [currentPage, paginationInfo?.pageCount, setCurrentPage]);

  const handleNextPage = () => {
    if (currentPage < pageCount) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  return (
    <PaginationRoot
      className={cn(
        'mt-4 border-t border-slate-100 px-1 py-3 justify-center sm:justify-end',
        className,
        'dark:border-slate-800 dark:text-slate-400'
      )}
    >
      <PaginationContent className="gap-3">
        <PaginationItem className="select-none">
          <PaginationPrevious
            onClick={handlePrevPage}
            aria-disabled={currentPage <= 1}
            tabIndex={currentPage <= 1 ? -1 : undefined}
            className={cn(
              currentPage <= 1 && 'pointer-events-none cursor-not-allowed opacity-50'
            )}
          />
        </PaginationItem>

        <PaginationItem className="select-none">
          <PaginationLink isActive className="h-12 w-12 rounded-xl text-base">
            {currentPage}
          </PaginationLink>
        </PaginationItem>

        <PaginationItem className="select-none">
          <PaginationNext
            onClick={handleNextPage}
            aria-disabled={currentPage >= pageCount}
            tabIndex={currentPage >= pageCount ? -1 : undefined}
            className={cn(
              currentPage >= pageCount && 'pointer-events-none cursor-not-allowed opacity-50'
            )}
          />
        </PaginationItem>
      </PaginationContent>
    </PaginationRoot>
  );
};
